import "./DownloadGame.css";
// import MenuVTC from "../../../Share/Component/MenuVtc";
import downloadInstallImage1 from "../../../Css/img_news/downloads/download_install1.jpg";
import downloadInstallImage2 from "../../../Css/img_news/downloads/download_install2.jpg";
import { getShuffledTableRows } from "../../../Constants/download";
import { useMemo } from "react";
import SupportGroupCard from "../../../Components/Atoms/SupportGroupCard";

const ZALO_SUPPORT_GROUP_URL = process.env.REACT_APP_ZALO_SUPPORT_GROUP_URL;

function SupportContactButton() {
  return (
    <a
      rel="noopener noreferrer"
      href={ZALO_SUPPORT_GROUP_URL}
      target="_blank"
      className="support-step-btn"
    >
      Liên hệ hỗ trợ
    </a>
  );
}

function DownloadGame() {
  const tableRows = useMemo(() => getShuffledTableRows(), []);

  return (
    <div className="main">
      <div className="content-main">
        <div className="content-center">
          <div className="download-main">
            <p title="Hướng dẫn tải" className="tit" href="#">
                          Tải Game PC: <span> miễn phí auto mPK, auto KeoXe, miễn phí giờ chơi   </span>
            </p>
          <div className="clearfix"></div>
             <div className="download-instruction-highlight">
                Tải chỉ 1 trong 3 link bên dưới là đủ tất cả     
            </div>
            <div className="download-option">
              <div className="package package-full">
                <div className="step step-download-table">
                  <div className="download-table-wrapper">
                    <table className="download-table">
                      <thead>
                        <tr>
                          <th>Link</th>
                          <th>Phương thức</th>
                          <th>Hướng dẫn</th>
                          <th>Điều kiện truy cập</th>
                          <th>Tốc độ</th>
                          <th>Tải xuống</th>
                          <th>Ghi chú</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableRows.map((row) => (
                          <tr key={row.linkId}>
                            <td>{row.linkId}</td>
                            <td>
                              {row.method.line1}
                              <br />
                              {row.method.nowrap ? (
                                <span className="download-table-nowrap">
                                  {row.method.line2}
                                </span>
                              ) : (
                                row.method.line2
                              )}
                            </td>
                            <td>{row.instruction}</td>
                            <td>{row.accessCondition}</td>
                            <td>{row.speed}</td>
                            <td>
                              <a
                                rel="noopener noreferrer"
                                href={row.url}
                                target="_blank"
                                className="download-table-btn"
                              >
                                TẢI NGAY
                              </a>
                            </td>
                            <td>{row.note}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="step step-2">
                  <div className="text">
                    <div>
                      Nếu
                      <span className="highlight">
                        xuất hiện bảng này thì làm theo bước 1 - 2
                      </span>
                    </div>
                  </div>
                  <div className="download">
                    <img
                      src={downloadInstallImage1}
                      alt="Hướng dẫn cài đặt 1"
                      className="install-image"
                    />
                    <img
                      src={downloadInstallImage2}
                      alt="Hướng dẫn cài đặt 2"
                      className="install-image"
                    />
                  </div>
                  <div className="text">
                    Bước 2:
                    <span className="highlight">
                      Nhấn chuột vào file exe cài đặt hoặc Giải nén file rar vừa
                      tải về. Không giải nén vào thư mục tên tiếng Việt, Nhật,
                      Hàn hoặc chữ có dấu ở đường dẫn
                    </span>
                    <SupportContactButton />
                    <div className="clearfix"></div>
                  </div>
                </div>
                <div className="step step-2">
                  <div className="text">
                    Bước 3:
                    <span className="highlight">
                      Tìm Autoupdate.exe để chạy ( tắt anti và giải nén lại nếu
                      không thấy)
                    </span>
                    <SupportContactButton />
                    <br />
                    <div className="clearfix"></div>
                  </div>
                </div>
                {/*<div className="step step-2">*/}
                {/*  <div className="text">*/}
                {/*    Bước 4:*/}
                {/*    <br />*/}
                {/*    <span className="highlight highlightStep4">*/}
                {/*      Nếu không tải hoặc cài đặt game, vui lòng nhắn tin kênh kĩ*/}
                {/*      thuật để nhận hỗ trợ thông qua ultra viewer*/}
                {/*    </span>*/}
                {/*    <br />*/}
                {/*    <a*/}
                {/*      rel="noopener noreferrer"*/}
                {/*      href={Path.SUPPORT}*/}
                {/*      target="_blank"*/}
                {/*    >*/}
                {/*      Liên hệ Kênh Hỗ trợ kĩ thuật tại đây*/}
                {/*    </a>*/}
                {/*    <div className="clearfix"></div>*/}
                {/*  </div>*/}
                {/*</div>*/}
              </div>
            </div>
            {/*<div className="clearfix"></div>*/}
            {/*<div className="step step-footer">*/}
            {/*  <ul className="info-news">*/}
            {/*    <li>*/}
            {/*      <a rel="noopener noreferrer" href={Path.chat} target="_blank">*/}
            {/*        Hỗ trợ, tư vấn, kênh kinh doanh tại đây*/}
            {/*      </a>*/}
            {/*    </li>*/}
            {/*    <li>*/}
            {/*      <a*/}
            {/*        rel="noopener noreferrer"*/}
            {/*        href={Path.Group}*/}
            {/*        target="_blank"*/}
            {/*      >*/}
            {/*        Nhóm cập nhật thông tin của server tại đây*/}
            {/*      </a>*/}
            {/*    </li>*/}
            {/*  </ul>*/}
            {/*</div>*/}
            <div className="border-footer block text-center"></div>
          </div>
        </div>

        {/* <MenuVTC /> */}
         <SupportGroupCard />
      </div>
    </div>
  );
}
export default DownloadGame;
